import React, { useEffect, useRef, useState } from "react";

/** Scouter-style scramble counter */
export default function ScouterNumber({ value = 0, decimals = 0, duration = 1200, suffix = "", className = "" }) {
  const [display, setDisplay] = useState("0");
  const rafRef = useRef(null);

  useEffect(() => {
    if (value === null || value === undefined) { setDisplay("--"); return; }
    const start = performance.now();
    const startVal = 0;
    const endVal = Number(value) || 0;
    const scramblePhase = duration * 0.55;

    const fmt = (n) => Number(n).toFixed(decimals);

    const tick = (now) => {
      const elapsed = now - start;
      if (elapsed < scramblePhase) {
        const noise = (endVal === 0 ? 100 : Math.max(10, Math.abs(endVal) * 2)) * Math.random();
        setDisplay(fmt(noise));
      } else if (elapsed < duration) {
        const t = (elapsed - scramblePhase) / (duration - scramblePhase);
        const eased = 1 - Math.pow(1 - t, 3);
        setDisplay(fmt(startVal + (endVal - startVal) * eased));
      } else {
        setDisplay(fmt(endVal));
        return;
      }
      rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [value, decimals, duration]);

  return (
    <span className={`big-numeric ${className}`} data-testid="scouter-number">
      {display}{suffix}
    </span>
  );
}
